import React, { useState, useEffect } from 'react';
import logo from './images/logo.min.svg';
import './App.css';


import Category from './Category/Category';
import NavFooter from './NavFooter';
import Subscribe from './Subscribe';
import Social from './Social';
import Footer from './Footer';

import PrrS from './images/Image-118.png'
import StoreImg from './images/store.jpg'
import closeIcon from './images/times-circle-regular.svg'

import getWpJson from './common/getWpJson'

import buildArticles from './common/buildArticles';


function App() {

  const initialState = { recents: [], briefings: [], politics: [], economy: [], life: [] }
  const databases = {recents: null, briefings: null, politics: null, economy: null, life: null}

  const [bannerActive, setBannerActive] = useState('banner active')
  const [getDb, setDb] = useState(databases)
  const [State, setState] = useState(initialState);

  useEffect(() => {
    async function fetchDatabases() {

      const dbRecents = getWpJson('https://www.caracaschronicles.com/wp-json/wp/v2/posts?per_page=5&categories=1005,1006,1007')
      const dbBriefings = getWpJson('https://www.caracaschronicles.com/wp-json/wp/v2/posts?per_page=1&categories=741')
      const dbPolitics = getWpJson('https://www.caracaschronicles.com/wp-json/wp/v2/posts?per_page=6&categories=1005')
      const dbEconomy = getWpJson('https://www.caracaschronicles.com/wp-json/wp/v2/posts?per_page=6&categories=1006')
      const dbLife = getWpJson('https://www.caracaschronicles.com/wp-json/wp/v2/posts?per_page=6&categories=1007')

      const response = await Promise.all([dbRecents, dbBriefings, dbPolitics, dbEconomy, dbLife])

      setDb({
        recents: response[0],
        briefings: response[1],
        life: response[2],
        economy: response[3],
        politics: response[4],
      })
    
    }

    fetchDatabases();
  },
  [])

  useEffect(() => {

    async function buildAllArticles() {

      if(getDb.recents == null) return;

      const recentArticles = buildArticles(getDb.recents, 'big');
      const briefings = buildArticles(getDb.briefings, 'briefing');

      const smallArticlesLife = buildArticles(getDb.life, 'small');
      const smallArticlesEconomy = buildArticles(getDb.economy, 'small');
      const smallArticlesPolitics = buildArticles(getDb.politics, 'small');

      const response = await Promise.all([recentArticles, briefings, smallArticlesLife, smallArticlesEconomy, smallArticlesPolitics])
      
      setState({
        recents: response[0],
        briefings: response[1],
        life: response[2],
        economy: response[3],
        politics: response[4],
      })
    }

    buildAllArticles();

  }, [getDb])


  if (State.recents[0] == null) {
    return <div className='loadScreen'></div>
  } else {
    return (
      <div className="App">
        <div className={bannerActive}><p>{//<!-- Icon made by dmitri13 from www.flaticon.com, thanks dmitri13 😏 -->
}
          ¡This is not the real Caracas Chronicles! This is a remake made <strong>from scratch</strong> in React 😋. To learn more about how this was made, <a href="https://github.com/carlos815/CC-clone">go here</a>. Every other link in this page will take you to the real site. 😇😇
        </p>
        <div onClick={() =>{setBannerActive('banner inactive')}}>
        <img src={closeIcon} alt="Close Icon" srcset=""/>


        </div>
        </div>
        <header className="App-header">
          <img src={logo} className="App-logo" alt="logo" />
          <div><p>
            Donate
        </p></div>
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 28 15">
            <g transform="translate(-418.596 -302.08)">
              <rect width="10" height="2" transform="translate(418.595 306.309)"></rect>
              <rect width="13" height="2" transform="translate(418.595 310.559)"></rect>
              <rect width="16" height="2" transform="translate(418.595 314.809)"></rect>
              <path d="M442.582,311.587a6,6,0,1,0-1.3,1.3l3.92,3.92,1.3-1.3-3.921-3.92Zm-4.825.619a4.143,4.143,0,1,1,4.143-4.142,4.147,4.147,0,0,1-4.143,4.142Z"></path>
            </g>
          </svg>
        </header>
        <div className='wrapper'>

          {State.recents}

          <figure className='PRR img-container'>
            <img src={StoreImg} alt="article" srcSet="" />
          </figure>


          {State.briefings}

        </div>
        <figure className='PRR img-container'>
          <img src={PrrS} alt="article" srcSet="" />
        </figure>

        <Category posts={State.politics} category={'Politics'} />
        <Category posts={State.economy} category={'Economy'} />
        <Category posts={State.life} category={'Life'} />



        <div className='footer-group'><img src={logo} className="App-logo-footer" alt="logo" />
          <NavFooter />
          <Subscribe />
          <Social />
          <Footer /></div>
      </div>
    );
  }
}

export default App;
